import { useContext, useEffect } from 'react';
import * as Sentry from "@sentry/react";
import AuthContext from '../../contexts/auth/AuthContext';
import { createSentryAnonymousUser } from '../../utilities/errors';


const useSentryUser = () => {
    const authenticatedUser = useContext(AuthContext);

// Psuedocode of an update when authenticated user changes.
    useEffect(() => {
        // no user, clear sentry user.
        if (!authenticatedUser.user) {
            // set Sentry User back to anonymous.
    
            Sentry.setUser(createSentryAnonymousUser());
            return;
        }
    
        // user, set sentry user.
        Sentry.setUser({
            id: authenticatedUser.user.userName,
            username: authenticatedUser.user.userName,
            fullName: authenticatedUser.user.fullName,
            authenticated: true
        })
    
        return () => {
            // set Sentry User back to anonymous.
    
            Sentry.setUser(createSentryAnonymousUser());
        }
    }, [authenticatedUser.user])
}

export default useSentryUser;